import React, { useEffect, useState } from 'react';
import { useResume } from '../context/ResumeContext';
import DraftEditor from './common/DraftEditor';
const Interests = (props) => {

  const {
    resume: {
      heading: { fname },
      interests,
      enabled_tabs
    },
    handlers: {
      updateResumePreview,
    },
  } = useResume();
  return (<div className="editor-form">
    <div className="form-row">
      <div className="field-wrap">

        <DraftEditor
          name="description"
          // placeholder="e.g. Passionate science teacher with 8+ years of experience and a track record of..."
          className="validate"
          value={interests?.content}
          //onChange={(e) => { props.updateJob({ description: e.target.value }, props.id) }}
          onInputChange={(val) => {
            updateResumePreview({
              interests: { ...interests, content: val },
              current_tab: 'additional_sections',
              
            });
          }}
        />
      </div>
    </div>
  </div>);
}

export default Interests;